export interface CityOption {
  id: string;
  name: string;
  pinyin?: string;
}

export const defaultCityContextValue = {
  id: '',
  name: '',
  pinyin: '',
  avg: NaN,
  latest_month_avg_salary: {},
  market_share: [],
  industry_salary: [],
  salary_top_ten: [],
  experience_distributed: {},
  adjacent_cities: [],
  avg_by_month: [],
};

export interface CityContextType {
  id: string;
  name: string;
  pinyin: string;
  avg: number;
  avg_median?: number | null;
  latest_month_avg_salary: Record<string, number>;
  market_share: { id: string; name: string; count: number }[];
  industry_salary: { id: string; name: string; avg: number }[];
  salary_top_ten: {
    id: string;
    name: string;
    job_titles: { avg: number; name: string; id: string }[];
  }[];
  experience_distributed: Record<string, number>;
  adjacent_cities: {
    rank: number;
    id: string;
    name: string;
    pinyin: string;
    avg: number;
    avg_median?: number | null;
    highest_salary_job: { avg: number; name: string; id: string };
    market_share_top_three: { id: string; name: string; count: number }[];
    current_city: boolean;
  }[];
  avg_by_month: { id: string; name: string; details: Record<string, number> }[];
}
